import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { Address } from '@lukso/controllerapps-sharedlogic-primitives'

const ProfileAddressPropsSchema = z.object({
  profileAddressValue: z.instanceof(Address),
})

type ProfileAddressProps = z.infer<typeof ProfileAddressPropsSchema>

export class ProfileAddress extends ValueObject<ProfileAddressProps> {
  public getValue(): Address {
    return this.props.profileAddressValue
  }

  /**
   * @returns A 0x-prefixed checksum-based hex string of the address.
   */
  public getChecksumValue(): string {
    return this.props.profileAddressValue.getChecksumValue()
  }

  public equals(other: ProfileAddress): boolean {
    return this.getChecksumValue() === other.getChecksumValue()
  }

  public static create(props: ProfileAddressProps): ProfileAddress {
    const validatedProps = ProfileAddressPropsSchema.parse(props)
    return new ProfileAddress(validatedProps)
  }
}
